import { Injectable } from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  constructor(private readonly confirmationService: ConfirmationService) { }

  public openYesNoModal(message: string, header: string, key: string |undefined = undefined) {
    const confirmation = new Subject<'yes' | 'no'>();
    this.confirmationService.confirm({
      message: message,
      header: header,
      closable: true,
      closeOnEscape: true,
      key: key,
      rejectButtonProps: {
        label: 'No',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Yes',
      },
      reject: () => {
        confirmation.next('no')
        confirmation.complete()
      },
      accept: () => {
        confirmation.next('yes')
        confirmation.complete()
      }
    });

    return confirmation;
  }
}
